import { render, staticRenderFns } from "./diapositiva-17.vue?vue&type=template&id=4620a89a&scoped=true&"
import script from "./diapositiva-17.vue?vue&type=script&lang=js&"
export * from "./diapositiva-17.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-17.vue?vue&type=style&index=0&id=4620a89a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620a89a",
  null
  
)

export default component.exports